import React, { Component } from "react";
// Styles
import "./NextLevel.scss";

// Components
import Header from "components/Header";
import Next from "static/img/next.svg";

import { sendData } from "services/ApiService";
import { secondTutorialLevel } from "utility/constants";

class NextLevel extends Component {
  constructor(props) {
    super(props);
    if (!props.location.level) this.props.history.replace("/level");
  }

  async componentDidMount() {
    if (!this.props.location.level) this.props.history.replace("/level");
    else {
      let { seconds, stats } = this.props.location;
      await sendData({ ...stats, seconds, completed: true });
    }
  }

  nextLevel(level, seconds, total, stats) {
    this.props.history.replace({
      pathname: level === secondTutorialLevel ? "/tutorial2" : "level",
      level: level,
      seconds: seconds,
      total: total,
      stats: stats,
    });
  }

  render() {
    let { level, seconds, total, stats } = this.props.location;
    return (
      <>
        <div className="level-layout next-level">
          <Header currentLevel={level - 1} total={total} seconds={seconds} />
          <div className="completion">
            <div className="completion-box">
              <div className="level">
                {(level - 1).toLocaleString("en-US", {
                  minimumIntegerDigits: 2,
                })}
              </div>
              <span className="awsm-text">Awesome!</span>
              <p className="next-step">You can proceed to the next round</p>
              <div className="btn-wrapper">
                <button
                  className="tab-for-next"
                  onClick={() => this.nextLevel(level, seconds, total, stats)}
                >
                  <span className="btn-text">
                    Start Level {level}
                    <img className="margin" src={Next} alt="next" />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default NextLevel;
